/**
 * src/components/directory/DirectoryHeader.js
 *
 * Encabezado de la sección: título, descripción y buscador de categorías.
 * Props: { headline, description, onSearch: (term: string) => void }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'

define('DirectoryHeader', ({ headline, description, onSearch }) => {
    const input = h('input', {
        type:        'text',
        className:   'dir-search__input',
        placeholder: 'Buscar categoría...'
    })

    input.addEventListener('input', () => onSearch(input.value.trim().toLowerCase()))

    const searchBox = h('div', { className: 'dir-search' },
        h('span', { className: 'dir-search__icon' }, '🔍'),
        input
    )

    return h('div', { className: 'dir-header' },
        h('h2', { className: 'dir-header__headline' }, headline),
        h('p',  { className: 'dir-header__desc' }, description),
        searchBox
    )
})
